import React, { useLayoutEffect, useState } from 'react';
import { BackHandler, SafeAreaView, StyleSheet, View } from 'react-native';
import BottomButton from '../BottomButton';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import PickerSelect from '../PickerSelect';
import { useSelector } from 'react-redux';
import { selectTripSummary } from '../../store/selectors/search.selector';
import InputForm from '../InputForm';
import { Screens } from '../../constants/ScreenNames';
import { i18nNS } from '../../i18n';
import { useTranslation } from 'react-i18next';
import { PROGRAM_NUMBER, PassengerVendorCode, searchTypesEnum } from '../../constants/Enums';

const determineInitialVendorLoyalty = (id, passengerIndex, formProps, type) => {
  const initialValues = {
    vendor: '',
    loyalty: '',
  };

  switch (type) {
    case searchTypesEnum.AIR:
      initialValues.vendor =
        formProps?.values?.passengers[passengerIndex]?.FrequentFlyers[id]?.AirLineCode;
      initialValues.loyalty =
        formProps?.values?.passengers[passengerIndex]?.FrequentFlyers[id]?.ProgramNo;
      break;
    case searchTypesEnum.HOTEL:
      initialValues.vendor =
        formProps?.values?.passengers[passengerIndex]?.HotelLoyalty[id]?.HotelChainCode;
      initialValues.loyalty =
        formProps?.values?.passengers[passengerIndex]?.HotelLoyalty[id]?.ProgramNumber;
      break;
    case searchTypesEnum.CAR:
      initialValues.vendor =
        formProps?.values?.passengers[passengerIndex]?.CarLoyalty[id]?.CarVendorCode;
      initialValues.loyalty =
        formProps?.values?.passengers[passengerIndex]?.CarLoyalty[id]?.ProgramNumber;
      break;
    default:
      break;
  }
  return initialValues;
};
const PassengerLoyaltyForm = ({ navigation, route }) => {
  const { id, passengerIndex, formProps, selectList, type } = route.params;
  const { t } = useTranslation(i18nNS.me);
  const initialValues = determineInitialVendorLoyalty(id, passengerIndex, formProps, type);
  const [vendorCode, setVendorCode] = useState(initialValues.vendor);
  const [loyaltyValue, setLoyaltyValue] = useState(initialValues.loyalty);
  const tripSummary = useSelector(selectTripSummary);
  const allAirLoyalties = tripSummary?.FrequentFlyers;
  const allHotelLoyalties = tripSummary?.HotelLoyaltys;
  const allCarLoyalties = tripSummary?.CarLoyaltys;
  const { AIR, HOTEL, CAR } = searchTypesEnum;
  const loyaltyIdKey = {
    [AIR]: PassengerVendorCode.AIR,
    [HOTEL]: PassengerVendorCode.HOTEL,
    [CAR]: PassengerVendorCode.CAR,
  }[type];
  const programNumberKey = type === AIR ? PROGRAM_NUMBER.AIR : PROGRAM_NUMBER.OTHERS;

  useLayoutEffect(() => {
    function handleBackButton() {
      navigation.navigate(Screens.Passenger);
      return true;
    }
    //handle back button android, IOS
    BackHandler.addEventListener('hardwareBackPress', handleBackButton);
    return () => BackHandler.removeEventListener('hardwareBackPress', handleBackButton);
  }, [navigation]);
  const handleModalClose = () => {
    switch (type) {
      case AIR:
        // Set the airline loyalty program code and number
        formProps.setFieldValue(
          `passengers[${passengerIndex}].FrequentFlyers[${id}].AirLineCode`,
          vendorCode
        );
        formProps.setFieldValue(
          `passengers[${passengerIndex}].FrequentFlyers[${id}].ProgramNo`,
          loyaltyValue
        );
        break;
      case HOTEL:
        // Set the hotel loyalty program code and number
        formProps.setFieldValue(
          `passengers[${passengerIndex}].HotelLoyalty[${id}].HotelChainCode`,
          vendorCode
        );
        formProps.setFieldValue(
          `passengers[${passengerIndex}].HotelLoyalty[${id}].ProgramNumber`,
          loyaltyValue
        );
        break;
      case CAR:
        // Set the car loyalty program code and number
        formProps.setFieldValue(
          `passengers[${passengerIndex}].CarLoyalty[${id}].CarVendorCode`,
          vendorCode
        );
        formProps.setFieldValue(
          `passengers[${passengerIndex}].CarLoyalty[${id}].ProgramNumber`,
          loyaltyValue
        );
        break;
      default:
        break;
    }
    navigation.navigate(Screens.Passenger);
  };

  const handleValueChange = (value, loyaltyArray) => {
    const hasResults = loyaltyArray.filter((x) => x[loyaltyIdKey] === value).length > 0;
    if (hasResults) {
      setLoyaltyValue(loyaltyArray.find((x) => x[loyaltyIdKey] === value)[programNumberKey]);
    }
    setVendorCode(value);
  };

  const typeToLoyaltyMap = {
    [AIR]: allAirLoyalties,
    [HOTEL]: allHotelLoyalties,
    [CAR]: allCarLoyalties,
  };
  return (
    <SafeAreaView style={CommonStyles.flex1}>
      <View style={styles.body}>
        <View style={styles.loyaltyContainer}>
          <PickerSelect
            isLoyalty={true}
            onValueChange={(value) => {
              if (typeToLoyaltyMap[type]) {
                handleValueChange(value, typeToLoyaltyMap[type]);
              }
            }}
            items={selectList}
            value={vendorCode}
          />
          <InputForm
            styleContainer={CommonStyles.my2}
            value={loyaltyValue}
            placeholder="Enter loyalty number"
            onChangeText={(value) => {
              setLoyaltyValue(value);
            }}
          />
        </View>
        <BottomButton onPress={handleModalClose} label={t('common:Save')} />
      </View>
    </SafeAreaView>
  );
};

export default PassengerLoyaltyForm;

const styles = StyleSheet.create({
  loyaltyContainer: {
    backgroundColor: Color.background,
    ...CommonProperties.my3,
    ...CommonProperties.p3,
  },
  body: {
    flex: 1,
    backgroundColor: Color.background,
  },
});
